import { TableColumn,  TableValueAction} from '../../../shared';
import {Adjunto} from "../../index";

export interface AdjuntoTableColumn extends TableColumn {
  literalFormat?: (v: any, adjunto: Adjunto) => string;
  actionFormat?: (adjunto: Adjunto, sources?: AdjuntoTableRowSource) => TableValueAction;
}

export interface AdjuntoTableParams {
  columns?: AdjuntoTableColumn[];
  adjuntos: Adjunto[];
  sources: AdjuntoTableRowSource;
  filter?: boolean;
  pagination?: boolean;
}

export interface AdjuntoTableRowSource {
  rolId: string;
  personaId: string;
}


